var styleDataHash = '0bec4597';  
export const injectCss = (() => {
  var css = `.j-DgM{position:relative}._6kY0s,.j-DgM{width:max-content}._6kY0s{align-items:center;display:flex;grid-column-gap:4px}.lDs1l{display:none}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "toolbarVisible": "j-DgM",
  "visibleItems": "_6kY0s",
  "hiddenToolbar": "lDs1l"
};